export const otherInsuranceMsg =
  "Please provide your insurance information in the space provided and a member of our team will be in touch to discuss your options.";